import React, { useEffect } from "react";
import "../../Styles/InputTemplate.scss";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import "react-dropzone-uploader/dist/styles.css";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import Api from "../../Services/Api";
import { process } from "@progress/kendo-data-query";
import XLSX from "xlsx";
import { toastr } from "react-redux-toastr";
import { Popup } from "@progress/kendo-react-popup";
import { NumericTextBox } from "@progress/kendo-react-inputs";
const delimiterArray=[
  {
    name: "Comma (,)",
    value: ","
  },
  {
    name: "Semicolon (;)",
    value: ";"
  },
  {
    name: "Colon (:)",
    value: ":"
  }
]

export default function RiskExcelImport(props) {
  const [riskwellColumn, setRiskwellColumn] = React.useState([]);
  const [dataState, setDataState] = React.useState({});
  const [loader, setLoader] = React.useState(false);
  const [templateName, setTemplateName] = React.useState(undefined);

  const [templateSheetName , setTemplateSheetName ] = React.useState(undefined);
  const [templateDelimiter, setTemplateDelimiter] = React.useState(delimiterArray[0]);
  const [selectedRowNumber, setSelectedRowNumber] = React.useState(1);
  const [exceluploadPopup, setExceluploadPopup] = React.useState(false);
  const [sheetNames, setSheetNames] = React.useState([]);
  const [fileObject, setFileObject] = React.useState(undefined);

  const [templateDescription, setTemplateDescription] = React.useState("");
  const [excelColumn, setExcelColumn] = React.useState([]);
  const [importFileName, setImportFileName] = React.useState(undefined);
  const [crossRefField, setCrossRefField] = React.useState("Threat/Opportunity");

  useEffect(() => {
    init();
    setDataState({
      sort: [],
      take: 10,
      skip: 0,
    });
  }, []);

  const init = async () => {
    await getRiskwellColumnsForRisk();
  };

  const getExcelTemplateById = async (riskwellColumnsForRisk) => {
    try {
      let req={
        TemplateId:props.templateId
      }
      let response = await Api.getExcelTemplateById(req);
      if (response.status === 200) {
        populateExistingValues(response.excelTemplateResponse,riskwellColumnsForRisk);
      }
    } catch (err) {
      console.error("Exception:", err);
    }
  };
const cancelpopup=()=>{
  setExceluploadPopup(false)
}
  const populateExistingValues = (excelTemplateResponse,riskwellColumnsForRisk) => {
    
    let data = riskwellColumnsForRisk.map((item) => {
      let temp = excelTemplateResponse.templateColumns.find(
        (cols) => cols.riskwellColumnName === item.riskwellGridColumnName
      );
      if (temp) {
        item["selected"] = true;
        item["excelColumnName"] = temp.excelColumnName;
      } else {
        item["selected"] = false;
        // item["excelColumnName"]=undefined;
      }
      return item;
    });
    let deli=delimiterArray.find((item)=>item.value===excelTemplateResponse?.templateDelimiter)||delimiterArray[0];
    setRiskwellColumn(data);
    setTemplateName(excelTemplateResponse?.templateName);
    setTemplateDescription(excelTemplateResponse?.templateDescription);
    setImportFileName(excelTemplateResponse?.templateExcelFileName);
    setTemplateDelimiter(deli);
    setCrossRefField(excelTemplateResponse?.templateCrossReference);

    setTemplateSheetName(excelTemplateResponse?.templateSheetName);
    setSelectedRowNumber(excelTemplateResponse?.selectedRowNumber);
    let arr=[];
    excelTemplateResponse.originalExcelColumns.map((item)=>{
      arr.push(item.originalExcelColumnName);
    });
    
    setExcelColumn(arr);
  };

  const getRiskwellColumnsForRisk = async () => {
    try {
      let response = await Api.getRiskwellColumnsForRisk();
      if (response.status === 200) {
        let data = response.riskwellColumnsForRisk.map((dataItem) =>
          Object.assign({ selected: true }, dataItem)
        );
        // Keep the first 4 elements
        const firstFour = data.slice(0, 3);
        // Sort the rest
        const sortedRest = data.slice(3).sort((a, b) => {
          return a.riskwellGridColumnName.localeCompare(
            b.riskwellGridColumnName
          );
        });

        // Combine the two
        const finalData = [...firstFour, ...sortedRest];
        setRiskwellColumn(finalData);
        if (props.templateId != 0) {
          getExcelTemplateById(finalData);
        }
      }
    } catch (err) {
      console.error("Exception:", err);
    }
  };
 
const getSortedList=()=>{
  let sortedlist = excelColumn.sort(function (a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });
  return sortedlist;
}
  const handleDropdown = (event) => {
    return (
      <td>
        <DropDownList
          value={event.dataItem.excelColumnName}
          data={getSortedList()}
          onChange={(e) => selectExcelColumn(e, event.dataItem)}
          defaultValue="-Select-"
          style={{ height: "20px" }}
        />
      </td>
    );
  };

  const selectExcelColumn = (e, dataItem) => {
    dataItem["excelColumnName"] = e.value===" [blank]"?null:e.value;
    setExcelColumn([...excelColumn]);//for refresh
  };

  const validateMandatoryField = (templateColumns) => {
    let flag = false;
    if (!templateColumns || templateColumns.length === 0) {
      flag = true;
    } else {
      let riskTitleObj = templateColumns.find(
        (obj) => obj.RiskwellColumnName === "Risk Title"
      );
      if (riskTitleObj && riskTitleObj.ExcelColumnName) {
        let toObj = templateColumns.find(
          (obj) => obj.RiskwellColumnName === "Threat / Opportunity"
        );
        if (toObj && toObj.ExcelColumnName) {
          flag = false;
        } else {
          flag = true;
        }
      } else {
        flag = true;
      }
    }
    return flag;
  };
  const handleSubmit = async () => {
    try {
      setLoader(true);
      let templateColumns = [];
      let originalExcelColumns=[];
      riskwellColumn.map((item) => {
        if (item.excelColumnName) {
          templateColumns.push({
            RiskwellColumnName: item.riskwellGridColumnName,
            ExcelColumnName: item.excelColumnName,
          });
        }
      });
      excelColumn.map((item)=>{
        originalExcelColumns.push({
          originalExcelColumnName:item
        })
      });

      let flag=validateMandatoryField(templateColumns);
      if(flag){
        toastr.error("Risk Tile and Threat/Opportunity is mandatory");
        return;
      }
      let request = {
        TemplateName: templateName,
        TemplateDescription: templateDescription,
        TemplateType: "risk",
        TemplateColumns: templateColumns,
        OriginalExcelColumns: originalExcelColumns,
        TemplateExcelFileName:importFileName,

        TemplateSheetName: templateSheetName,
        TemplateDelimiter: templateDelimiter.value,
        SelectedRowNumber: selectedRowNumber,
        TemplateCrossReference:crossRefField
      };
      let response = await Api.addExcelTemplate(request);
      if (response.status === 200) {
        setLoader(false);
        toastr.success(response.message);
        props.handleclose();
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  };
  const handleUpdate = async () => {
    try {
      setLoader(true);
      let templateColumns = [];
      let originalExcelColumns=[];
      riskwellColumn.map((item) => {
        if (item.excelColumnName) {
          templateColumns.push({
            RiskwellColumnName: item.riskwellGridColumnName,
            ExcelColumnName: item.excelColumnName,
          });
        }
      });
      excelColumn.map((item)=>{
        originalExcelColumns.push({
          originalExcelColumnName:item
        })
      });
      let flag=validateMandatoryField(templateColumns);
      if(flag){
        toastr.error("Risk Tile and Threat/Opportunity is mandatory");
        return;
      }
      let request = {
        TemplateName: templateName,
        TemplateDescription: templateDescription,
        TemplateType: "risk",
        TemplateColumns: templateColumns,
        OriginalExcelColumns: originalExcelColumns,
        TemplateExcelFileName: importFileName,
        TemplateId: props.templateId != 0 ? props.templateId : null,

        TemplateSheetName: templateSheetName,
        TemplateDelimiter: templateDelimiter.value,
        SelectedRowNumber: selectedRowNumber,
        TemplateCrossReference:crossRefField
      };
      let response = await Api.updateExcelTemplate(request);
      if (response.status === 200) {
        setLoader(false);
        toastr.success(response.message);
        props.handleclose();
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  };


  const handleUpload = (event) => {
    setExcelColumn([]);
    setSheetNames([]);
    setTemplateSheetName(undefined);
    setSelectedRowNumber(0);
    setExceluploadPopup(true);
    setFileObject(event.target.files[0]);
    var f = event.target.files[0];
    var name = f ? f.name : "invalid file";
    setImportFileName(name);
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      setSheetNames(workbook.SheetNames);
    };
    reader.readAsArrayBuffer(f);
  };

  const handleFileUpload = () => {
    let event=fileObject;
    const file = event;
    const reader = new FileReader();
    
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = templateSheetName;//workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const headersRow = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: selectedRowNumber - 1 })[0];
      let headersRowArr = headersRow.map((item) => {
        return item?item.replace(/[\n\r]/g, "").trim():null;
      });
      let dupliacteRemovedArray=headersRowArr.filter((item, index) => headersRowArr.indexOf(item) === index&&item!=null);
      dupliacteRemovedArray.push(" [blank]");
      setExcelColumn(dupliacteRemovedArray);
      setExceluploadPopup(false);
    };
    
    reader.readAsArrayBuffer(file);
  };
  return (
    <div
      style={{
        margin: "4px",
        backgroundColor: "#1f2222b0",
        paddingBottom: "10px",
      }}
    >
      <div className="ImportColumn">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
              }}
            >
              <label className="templatelabel">Template Name</label>
              <input
                type="text"
                value={templateName}
                className="templatename"
                onChange={(e) => setTemplateName(e.target.value)}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "20px",
              }}
            >
              <label className="Descriptionlabel">Description</label>
              <textarea
                autoComplete="off"
                value={templateDescription}
                onChange={(e) => setTemplateDescription(e.target.value)}
                className="Description"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "20px",
              }}
            >
              <label className="Delimiterlabel">Delimiter</label>

              <DropDownList
                value={templateDelimiter}
                data={delimiterArray}
                onChange={(e) => setTemplateDelimiter(e.target.value)}
                defaultValue="-Select-"
                style={{ width: "400px", marginTop: "10px" }}
                textField="name"
                id="value"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "20px",
              }}
            >
              <label className="Delimiterlabel">Cross Reference Field</label>

              <DropDownList
                value={crossRefField}
                data={["Threat/Opportunity"]}
                onChange={(e) => setCrossRefField(e.target.value)}
                defaultValue="-Select-"
                style={{ width: "400px", marginTop: "10px" }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "20px",
              width: "400px",
              marginLeft: "40px",
            }}
          >
            <div className="exportDialogCont">
              <div className="uploadSec">
                <div className="innerBorder">
                  <p>Upload Your Risk File</p>
                  <span style={{ marginTop: "4px" }}>
                    {importFileName
                      ? importFileName
                      : "File should be in .xlsx format"}
                  </span>
                  <input type="file" accept=".xlsx" onChange={handleUpload} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="tblCont dataGrids">
            <div className="rw-tab-content" id="riskexcelimport">
              <Grid
                data={process(riskwellColumn, dataState)}
                pageable
                // selectedField="selected"
                onDataStateChange={(e) => {
                  setDataState(e.dataState);
                }}
                {...dataState}
              >
                <Column
                  field="riskwellGridColumnName"
                  title="Riskwell Column"
                  locked={true}
                  // className="riskwellcolumn-name"
                  width="500px"
                />
                <Column
                  field="excelColumn"
                  locked={true}
                  editable
                  title="Column Name From Excel"
                  cell={handleDropdown}
                  width="250px"
                />
              </Grid>
            </div>
          </div>
        </div>
        {/*   } */}
        <div className="action_btn">
          <button
            onClick={props.templateId != 0 ? handleUpdate : handleSubmit}
            disabled={!templateSheetName || !selectedRowNumber || !templateName}
            className="Submit__btn"
          >
            {props.templateId != 0 ? "Update" : "Submit"}
          </button>
          <button className="Cancel_btn" onClick={props.handleclose}>
            Cancel
          </button>
        </div>
      </div>
      <Popup show={exceluploadPopup} popupClass={"popup-content"}>
        <div className="importriskpoup">
          <div className="importheader">
            <h3>Risk Import File</h3>
          </div>

          <div className="col">
            <div className="SelectExcelSheet">
              <label>Select Sheet: </label>
              <DropDownList
                data={sheetNames}
                onChange={(e) => setTemplateSheetName(e.target.value)}
                value={templateSheetName}
                defaultValue="-Select-"
                className="ExcelSheet"
              />
            </div>
            <div className="SelectExcelRow">
              <label>Select Header Row </label>
              <NumericTextBox
                value={selectedRowNumber}
                className="ExcelRow"
                onChange={(e) => setSelectedRowNumber(e.target.value)}
                min={0}
              />
            </div>
            <div className="btnCont">
              <div className="action__btn">
                <button
                  onClick={() => handleFileUpload()}
                  disabled={!templateSheetName || !selectedRowNumber}
                  className="Submit__btn"
                >
                  Submit
                </button>
                <button className="Cancel_btn" onClick={() => cancelpopup()}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}
